module.exports = __webpack_public_path__ + "static/media/loading.94bc95f9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.gif
// module id = 662
// module chunks = 0